import { of, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SurveyService, State } from '../services';

export const survey = (surveySvc: SurveyService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (
        state.system?.survey === undefined ||
        typeof state.system.survey != 'number'
      )
        return of([state, currentState] as [Partial<State>, State]);
      const version = state.system.survey;
      return surveySvc.getSurvey$(currentState.campaignId!, version).pipe(
        map(
          (survey) =>
            [
              {
                ...state,
                ...{
                  system: {
                    ...state.system,
                    survey,
                  },
                },
              },
              currentState,
            ] as [Partial<State>, State]
        )
      );
    })
  );
